/**
 * Estabelecimento Delete Dialog Component
 */

import { GenericDeleteDialog } from "@/components/ui/generic-delete-dialog";
import { Estabelecimento } from "@/types/estabelecimento";

interface EstabelecimentoDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  estabelecimento: Estabelecimento | null;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function EstabelecimentoDeleteDialog({
  open,
  onOpenChange,
  estabelecimento,
  onConfirm,
  isLoading = false,
}: EstabelecimentoDeleteDialogProps) {
  return (
    <GenericDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      item={estabelecimento}
      onConfirm={onConfirm}
      isLoading={isLoading}
      entityName="Estabelecimento"
      getItemLabel={(e) => e.nome}
    />
  );
}
